import { ValueOpportunityContainer } from '@/features/decisions/components/value-opportunity/ValueOpportunityContainer';

export function ValueOpportunity() {
  return <ValueOpportunityContainer />;
}
